import React, { useState } from "react";
import {
  TRANSLATE_ERROR_ANONYMITY,
  TRANSLATE_ERROR_DISABLED,
  TRANSLATE_ERROR_GENERIC,
  TRANSLATE_MODE_ENGLISH,
  TRANSLATE_MODE_ORIGINAL,
  TRANSLATE_NOTICE_BUSY,
  TRANSLATE_NOTICE_RATE_LIMITED,
  TRANSLATE_STATUS_DONE,
  TRANSLATE_STATUS_RUNNING,
} from "../../../../utils/translateResponsesCore";
import {
  TRANSLATE_LABEL,
  TRANSLATE_MESSAGE_ANONYMITY,
  TRANSLATE_MESSAGE_BUSY,
  TRANSLATE_MESSAGE_DISABLED,
  TRANSLATE_MESSAGE_ERROR,
  TRANSLATE_MESSAGE_RATE_LIMITED,
  TRANSLATE_MESSAGE_UNAVAILABLE,
  TRANSLATE_OPTION_ENGLISH,
  TRANSLATE_OPTION_ORIGINAL,
  TRANSLATE_RETRY_LABEL,
  buildTranslateProgress,
  buildTranslateSummary,
} from "../../../../utils/triviaResultsStrings";
import "./TranslateToggle.css";

let translateToggleInstances = 0;

const STATUS_TEXT_CLASS = "translate-toggle-status-text";

// Shared By User "Translate" card; `translation` is the useTranslatedResponses
// return value, so Messages and Survey/KC render the exact same control.
const TranslateToggle = ({ translation }) => {
  const [uid] = useState(() => {
    translateToggleInstances += 1;
    return translateToggleInstances;
  });
  const { mode, setMode, status, progress, error, retry } = translation;
  const labelId = `translate-toggle-label-${uid}`;
  const groupName = `translate-toggle-mode-${uid}`;

  const renderStatus = () => {
    if (error) {
      if (error.kind === TRANSLATE_ERROR_GENERIC) {
        return (
          <p className={`${STATUS_TEXT_CLASS} text-danger`}>
            {TRANSLATE_MESSAGE_ERROR}
            <button type="button" className="translate-toggle-retry" onClick={retry}>
              {TRANSLATE_RETRY_LABEL}
            </button>
          </p>
        );
      }
      let message = TRANSLATE_MESSAGE_UNAVAILABLE;
      if (error.kind === TRANSLATE_ERROR_ANONYMITY) {
        message = TRANSLATE_MESSAGE_ANONYMITY;
      } else if (error.kind === TRANSLATE_ERROR_DISABLED) {
        message = TRANSLATE_MESSAGE_DISABLED;
      }
      return <p className={STATUS_TEXT_CLASS}>{message}</p>;
    }
    if (status === TRANSLATE_STATUS_RUNNING) {
      if (progress.notice === TRANSLATE_NOTICE_BUSY) {
        return <p className={STATUS_TEXT_CLASS}>{TRANSLATE_MESSAGE_BUSY}</p>;
      }
      if (progress.notice === TRANSLATE_NOTICE_RATE_LIMITED) {
        return <p className={STATUS_TEXT_CLASS}>{TRANSLATE_MESSAGE_RATE_LIMITED}</p>;
      }
      return (
        <p className={STATUS_TEXT_CLASS}>
          {buildTranslateProgress(progress.checked, null)}
        </p>
      );
    }
    if (status === TRANSLATE_STATUS_DONE) {
      return (
        <p className={STATUS_TEXT_CLASS}>
          {buildTranslateSummary(
            progress.translated,
            progress.failed,
            progress.pending
          )}
        </p>
      );
    }
    return null;
  };

  return (
    <div className="translate-toggle d-flex flex-column align-items-center mb-3">
      <div className="translate-toggle-card">
        <div id={labelId} className="translate-toggle-eyebrow">
          {TRANSLATE_LABEL}
        </div>
        <div
          role="radiogroup"
          aria-labelledby={labelId}
          className="translate-toggle-options"
        >
          <label className="translate-toggle-option">
            <input
              type="radio"
              name={groupName}
              value={TRANSLATE_MODE_ORIGINAL}
              checked={mode === TRANSLATE_MODE_ORIGINAL}
              onChange={() => setMode(TRANSLATE_MODE_ORIGINAL)}
            />
            {TRANSLATE_OPTION_ORIGINAL}
          </label>
          <label className="translate-toggle-option">
            <input
              type="radio"
              name={groupName}
              value={TRANSLATE_MODE_ENGLISH}
              checked={mode === TRANSLATE_MODE_ENGLISH}
              onChange={() => setMode(TRANSLATE_MODE_ENGLISH)}
            />
            {TRANSLATE_OPTION_ENGLISH}
          </label>
        </div>
      </div>
      <div aria-live="polite">{renderStatus()}</div>
    </div>
  );
};

export default TranslateToggle;
